/*
 *   File : add-note.js
 *   Author : https://evoqins.com
 *   Description : Create note modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';

//Custom components
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { CustomTextArea } from '../FormElements';
import { APIService } from '../../Service';
import { toast } from 'react-toastify';

const DATA = [
    {
        id: 1,
        label: 'Sample 1',
        value: 'Sample 1',
    },
    {
        id: 2,
        label: 'Sample 2',
        value: 'Sample 2',
    },
    {
        id: 3,
        label: 'Sample',
        value: 'Sample 3'
    },
    {
        id: 4,
        label: 'Sample',
        value: 'Sample'
    }
];

const AddNoteModal = (props) => {

    const [note, setNote] = useState("");
    const [noteError, setNoteError] = useState("");
    const [buttonLoader, setButtonLoader] = useState(false);

    useEffect(() => {
        if (Object.keys(props.editData).length !== 0) {
            setNote(props.editData.note);
        }
    }, [props.editData]);

    useEffect(() => {
        setNoteError("");
    }, [note]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("add-note-modal-close");
        button.click();
        props.handleClose();
    };

    // handle add note
    const _handleAdd = () => {
        let is_valid = true;

        if (note.trim().length === 0) {
            setNoteError("Please provide message");
            is_valid = false;
        }

        if (is_valid === true) {
            _updateLead();
        }
    };

    // API - Update lead
    const _updateLead = () => {
        let is_post = true;
        let url = 'lead/update-lead';
        let data = {
            "lead_id": Number(props.id),
            "note": note,
            "note_id": props.editData.note_id,
            "type": 1,
            "next_follow_up_date": null,
            "lead_stage_id": null
        };
        setButtonLoader(true);

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                _handleCloseModal();
                props.handleSuccess();
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setButtonLoader(false);
        });
    };


    return (
        <div className="modal fade"
            id="add-note-modal" data-bs-backdrop="static" data-bs-keyboard="false"
            tabIndex="-1" aria-labelledby="addNoteModalLabel" aria-hidden="true">
            <div className={`modal-lg modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28`}>
                <span id='add-note-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className=" modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark">
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-4">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            {props.edit ? "Edit note" : "Add Note"}
                        </h6>
                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className={`modal-body pt-0 padding-32px-lr padding-32px-bottom`}>
                        <CustomTextArea label="Add note"
                            placeholder="Enter note here"
                            type="text"
                            value={note}
                            error={noteError}
                            required={true}
                            className="w-100"
                            borderStyle="e-border-0-5px-arsenic"
                            handleChange={(e) => setNote(e)} />
                    </div>

                    {/* Modal footer */}
                    <div className='modal-footer border-0 pt-0 padding-32px-lr padding-32px-bottom gap-4'>
                        <SecondaryButton name="Cancel"
                            className="py-3 padding-70px-lr"
                            onClick={_handleCloseModal} />
                        <PrimaryButton name={props.edit ? "Save" : "Add"}
                            className="padding-78px-lr py-3"
                            loader={buttonLoader}
                            onClick={_handleAdd} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddNoteModal;

AddNoteModal.defaultProps = {
    handleClose: () => { }
};